import type React from 'react';
import {
  CheckmarkCircleRegular,
  ErrorCircleRegular,
  InfoRegular,
  WarningRegular,
  type FluentIcon,
} from '@fluentui/react-icons';
import { tokens } from '@fluentui/react-components';
import type { AlertSeverity } from '../models/alert';

/** Outline Fluent icon paired with each alert severity. */
export const SEVERITY_ICONS: Record<AlertSeverity, FluentIcon> = {
  Info:     InfoRegular,
  Success:  CheckmarkCircleRegular,
  Warning:  WarningRegular,
  Critical: ErrorCircleRegular,
};

/**
 * Foreground color token to apply to the severity icon. Uses Fluent palette
 * tokens so the icons stay coherent with theme switches.
 */
export const SEVERITY_ICON_COLORS: Record<AlertSeverity, string> = {
  Info:     tokens.colorPaletteBlueForeground2,
  Success:  tokens.colorPaletteGreenForeground1,
  Warning:  tokens.colorPaletteDarkOrangeForeground1,
  Critical: tokens.colorPaletteRedForeground1,
};

export const getSeverityIcon = (severity: AlertSeverity): React.ComponentType<{ className?: string; style?: React.CSSProperties }> =>
  SEVERITY_ICONS[severity];

export const getSeverityColor = (severity: AlertSeverity): string =>
  SEVERITY_ICON_COLORS[severity];
